import * as React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function Tile(props) {
    return (
        <Paper style={{ padding: '10px' }}>
            <Typography variant="subtitle1" style={{textTransform: 'capitalize'}}>
                {props.data.title}
            </Typography>
            <Typography variant="h4" noWrap>
                {props.data.message}
            </Typography>
        </Paper>
    );
}
